import { render, staticRenderFns } from "./MypageFavoriteTeamInitSelectPage.vue?vue&type=template&id=387c2772"
import script from "./MypageFavoriteTeamInitSelectPage.vue?vue&type=script&lang=ts"
export * from "./MypageFavoriteTeamInitSelectPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports